/**
 * Unsaved forms kept in `localStorage` (decision 182, U10). Every key starts with
 * {@link DRAFT_PREFIX} and names the user and the organization it belongs to, so one person never
 * reads another's draft; signing out drops them all, because the browser may be shared.
 */
export const DRAFT_PREFIX = 'console:draft:';

/** Copies written before the drafts were scoped: one key for everybody, never read again. */
const UNSCOPED_PREFIX = 'console:expense-form:';

/** The key of one draft: `kind` (the form), its owner, their organization, and `id` (the item). */
export function draftKey(
  kind: string,
  scope: { readonly userId: string; readonly tenantId: string; readonly organizationId: string },
  id: string,
): string {
  return `${DRAFT_PREFIX}${kind}:${scope.userId}:${scope.tenantId}:${scope.organizationId}:${id}`;
}

/** Drops every kept draft, of every user and organization (sign-out, or another account). */
export function clearLocalDrafts(): void {
  try {
    const keys: string[] = [];
    for (let index = 0; index < window.localStorage.length; index += 1) {
      const key = window.localStorage.key(index);
      if (key?.startsWith(DRAFT_PREFIX) || key?.startsWith(UNSCOPED_PREFIX)) keys.push(key);
    }
    for (const key of keys) window.localStorage.removeItem(key);
  } catch {
    // Storage blocked: nothing was kept either.
  }
}
